module.exports = {"610522001":"城关街道","610522101":"秦东镇","610522102":"太要镇","610522103":"桐峪镇","610522104":"代字营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610522.json
// module id = 2615
// module chunks = 0